import Api from "../../axios";

export const getCompOffRequest = async (employeeId, financialYear) => {
  return employeeId
    ? await Api.get(
        `/get_compoff_list?employee_id=${employeeId}&financial_year=${financialYear}`,
      )
    : await Api.get(`/get_compoff_list?financial_year=${financialYear}`);
};
